module.exports = __webpack_public_path__ + "images/Difital-Forum.a6cae8e4.webp";